import React from 'react';
import { Image, View, Text, StyleSheet } from 'react-native';
import InfluencerWorkoutImage from '../assets/images/influencerWorkout.png';
import Theme from '../theme';
import { defaultScale } from '../utils/scaling';

export const BulletPoint = ({ children }) => {
  return (
    <View style={styles.bulletPointContainer}>
      <Text style={[styles.normalText, { marginRight: defaultScale(8) }]}>
        {'\u2022'}
      </Text>
      {children}
    </View>
  );
};

interface IProps {
  preWorkoutTalk: boolean;
  streamerWillDropOffAfterTalk: boolean;
  t: (str: string, options?: { [key: string]: string }) => string;
}

export const InfluencerLearnMorePartOne = ({ t, preWorkoutTalk, streamerWillDropOffAfterTalk }: IProps) => {
  return (
    <>
      <BulletPoint>
        <Text style={styles.normalText}>
          {t('whatYouCanExpectBulletPointOnePartOne')}
          <Text style={styles.boldText}>
            {t('whatYouCanExpectBulletPointOnePartTwo')}
          </Text>
          {t('whatYouCanExpectBulletPointOnePartThree')}
        </Text>
      </BulletPoint>

      <BulletPoint>
        {preWorkoutTalk && !streamerWillDropOffAfterTalk &&
          <>
            <Text style={styles.normalText}>
              {t('whatToExpectPointTwoTalkUserStayingOne')}
              <Text style={styles.boldText}>
                {t('whatToExpectPointTwoTalkUserStayingTwo')}
              </Text>
              {t('whatToExpectPointTwoTalkUserStayingThree')}
              <Text style={styles.boldText}>
                {t('whatToExpectPointTwoTalkUserStayingFour')}
              </Text>
              {t('whatToExpectPointTwoTalkUserStayingFive')}
            </Text>
          </>
        }
        {preWorkoutTalk && streamerWillDropOffAfterTalk &&
          <>
            <Text style={styles.normalText}>
              {t('whatToExpectPointTwoTalkUserLeavingOne')}
              <Text style={styles.boldText}>
                {t('whatToExpectPointTwoTalkUserLeavingTwo')}
              </Text>
              {t('whatToExpectPointTwoTalkUserLeavingThree')}
            </Text>
          </>
        }
        {!preWorkoutTalk &&
          <Text style={styles.normalText}>
            {t('whatYouCanExpectBulletPointOnePartFour')}
            <Text style={styles.boldText}>
              {t('whatYouCanExpectBulletPointOnePartFive')}
            </Text>
            {t('whatYouCanExpectBulletPointOnePartSix')}
          </Text>
        }
      </BulletPoint>

      <BulletPoint>
        <Text style={styles.normalText}>
          {t('whatYouCanExpectBulletPointTwoPartOne')}
          <Text style={styles.boldText}>
            {t('whatYouCanExpectBulletPointTwoPartTwo')}
          </Text>
          {t('whatYouCanExpectBulletPointTwoPartThree')}
        </Text>
      </BulletPoint>

      <Image source={InfluencerWorkoutImage} style={styles.imageStyle} />
    </>
  );
};

const styles = StyleSheet.create({
  normalText: {
    ...Theme.textStyle.bodyCopyReg,
  },
  boldText: {
    ...Theme.textStyle.bodyCopyBold,
  },
  bulletPointContainer: {
    flexDirection: 'row',
    marginBottom: defaultScale(10),
    paddingRight: defaultScale(10),
  },
  imageStyle: {
    width: defaultScale(226),
    height: defaultScale(267),
    resizeMode: 'contain',
    alignSelf: 'center',
  },
});
